import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, IconButton, Typography } from '@/shared/ui';

import { spacing } from '@/config/ui';
import type { ApiKeyOutput } from '@/features/profile/TokenGeneration/api';
import copyToClipboard from '@/shared/lib/copyToClipboard';
import Loader from '@/shared/ui/feedback/Spinner';
import { DialogButton } from '@/shared/ui/overlays/Modal';

type PostGenerationBodyProps = {
  handleClose: () => void;
  isError: boolean;
  loading: boolean;
  newApiKey: ApiKeyOutput | null;
  exportToCsv: () => void;
};

const PostGenerationBody = ({
  handleClose,
  isError,
  loading,
  newApiKey,
  exportToCsv
}: PostGenerationBodyProps) => {
  if (isError) {
    return (
      <>
        <DialogContent>
          <Typography>Error generating ApiKey</Typography>
          <Typography>Please contact the General Index support team.</Typography>
        </DialogContent>
        <DialogActions sx={{ mt: spacing[2] }}>
          <DialogButton
            variant='text'
            onClick={handleClose}
          >
            Close
          </DialogButton>
        </DialogActions>
      </>
    );
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <IconButton
        aria-label='close'
        sx={{ position: 'absolute', right: 16, top: 16, color: 'gx.text' }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <Typography>Your token has been created. You can now retrieve the API token.</Typography>
      <DialogActions sx={{ mt: spacing[2] }}>
        <DialogButton
          variant='outlined'
          onClick={() =>
            copyToClipboard(newApiKey?.prefixedRawApiKey ?? '', 'Api key copied to clipboard!')
          }
        >
          Copy token
        </DialogButton>
        <DialogButton
          variant='outlined'
          onClick={exportToCsv}
        >
          Download as CSV file
        </DialogButton>
      </DialogActions>
    </>
  );
};

export default PostGenerationBody;
